/*
  Växlar köpläge PER VARIANT på en produkt som bär flera prismodeller (v2).

  Bakgrund: köpblocket avgjorde läge på PRODUKTEN – `matt_typ`/`prisregler` lästes en gång och
  hela sidan blev antingen lagerköp eller måttkonfigurator. `sattsteg` är båda samtidigt: fyra
  material är lagervaror med fasta längder, medan furu 21 mm och MDF 19 mm bara finns
  måttbeställda (de stänger en öppen trappa – höjden ÄR måttet, det finns ingen standardhöjd).

  Liquid renderar därför BÅDA lägena och den här filen visar rätt ett. Ingen sektionshämtning,
  ingen ommontering av konfiguratorn: den initieras en gång per modell vid sidladdning och
  ligger dold tills dess variant väljs.
*/
(function () {
  var kartEl = document.querySelector('[data-pk-vaxel]');
  if (!kartEl) return;

  var karta;
  try { karta = JSON.parse(kartEl.textContent); } catch (e) { return; }

  var konfar = [].slice.call(document.querySelectorAll('[data-wubs-pk][data-pk-modell]'));
  if (!konfar.length) return;

  var form = document.querySelector('[data-pdp-form]');
  var prisEl = document.querySelector('[data-pdp-price]');

  function visa(variantId) {
    var nyckel = karta[String(variantId)] || null;

    konfar.forEach(function (el) {
      var min = el.getAttribute('data-pk-modell') === nyckel;
      el.hidden = !min;
      // Konfiguratorn läser variant-id ur roten när den lägger i varukorgen.
      if (min) el.setAttribute('data-variant', variantId);
    });

    // Lagerformuläret och det statiska priset hör ihop: båda gäller bara lagervarianterna.
    // ⚠️ Priset döljs för måttbeställda – där sätter konfiguratorn priset, och ett statiskt
    //    "Från 375 kr" bredvid en måttberäknad summa hade varit två priser som säger olika.
    if (form) form.hidden = !!nyckel;
    if (prisEl) prisEl.hidden = !!nyckel;
  }

  document.addEventListener('wubs:variant:change', function (e) {
    if (e.detail && e.detail.variantId) visa(e.detail.variantId);
  });

  // Första renderingen: Liquid vet redan vald variant, men lägena är dolda som utgångsläge.
  var start = document.querySelector('[data-pdp-variant-id]');
  var konf = konfar[0];
  visa(start ? start.value : (konf ? konf.getAttribute('data-variant') : null));
})();
